'use client';

import { useSyncExternalStore } from "react";

const noopSubscribe = () => () => {};

export default function MailtoLink({ email, subject, children, ...anchorProps }) {
  const isClient = useSyncExternalStore(noopSubscribe, () => true, () => false);
  const query = subject ? `?subject=${encodeURIComponent(subject)}` : "";
  const href = isClient ? `mailto:${email}${query}` : undefined;

  return (
    <a href={href} {...anchorProps}>
      {children}
    </a>
  );
}
